module.exports = __webpack_public_path__ + "static/media/FacebookLogo.abd3a2c9.svg";